import { ILabelValuePair, sortOrderTypes } from 'types/shared';

type MetricLookup = { [key: string]: IMetric };

export interface IMetric extends ILabelValuePair<string> {
  key: string;
  type?: MetricType;
  range?: string;
  deprecatedKey?: string;
  change?: string;
  count?: string;
  isRange?: boolean;
  withoutSubLabel?: boolean;
  sortOrder?: sortOrderTypes | string;
}

export type MetricType = 'number' | 'trend';

const metrics: MetricLookup = {
  twtd: {
    label: 'This week to date',
    value: 'twtd',
    key: 'twtd',
    deprecatedKey: 'count_this_week_to_date',
    type: 'number',
    range: 'twtdRange',
    change: 'wowInProgress',
  },
  twtdOfGlobal: {
    label: `% of Global this week to date`,
    value: 'twtdOfGlobal',
    key: 'twtdOfGlobal',
    type: 'trend',
  },
  lw: {
    label: 'Last full week',
    value: 'lw',
    key: 'lw',
    type: 'number',
    range: 'lwRange',
    change: 'wowLastCompleted',
  },
  wowLastCompleted: {
    label: 'Last full week',
    value: 'wowLastCompleted',
    key: 'wowLastCompleted',
    type: 'trend',
    range: 'wowLastCompletedRange',
    count: 'countLastWeek',
  },
  lwtd: {
    label: 'Last week to date',
    value: 'lwtd',
    key: 'lwtd',
    deprecatedKey: 'count_last_week_to_date',
    type: 'number',
    range: 'lwtdRange',
  },
  rtd: {
    label: 'Release to date',
    value: 'rtd',
    key: 'rtd',
    deprecatedKey: 'performance_rtd',
    type: 'number',
    range: 'rtdRange',
  },
  count_rtd: {
    label: 'Release to date',
    value: 'count_rtd',
    key: 'count_rtd',
    type: 'number',
  },
  wowInProgress: {
    label: 'This week to date',
    value: 'wowInProgress',
    key: 'wowInProgress',
    deprecatedKey: 'wow_in_progress',
    type: 'trend',
    range: 'wowInProgressRange',
    count: 'countThisWeekToDate',
  },
  countThisWeekToDate: {
    label: 'This week to date',
    value: 'countThisWeekToDate',
    key: 'countThisWeekToDate',
    type: 'number',
    range: 'countThisWeekToDateRange',
    change: 'wowInProgress',
  },
  wow_in_progress: {
    label: 'This week to date',
    value: 'wow_in_progress',
    key: 'wow_in_progress',
    type: 'trend',
    range: 'wow_in_progress_range',
    count: 'count_this_week_to_date',
  },
  count_this_week_to_date: {
    label: 'This week to date',
    value: 'count_this_week_to_date',
    key: 'count_this_week_to_date',
    type: 'number',
    range: 'count_this_week_to_date_range',
    change: 'wow_in_progress',
  },
  countLastWeek: {
    label: 'Last full week',
    value: 'countLastWeek',
    key: 'countLastWeek',
    type: 'number',
    range: 'countLastWeekRange',
    change: 'wowLastCompleted',
  },
  performance_this_week_to_date: {
    label: 'This week to date',
    value: 'performance_this_week_to_date',
    key: 'performance_this_week_to_date',
    range: 'performance_this_week_to_date_range',
    change: 'performance_wow_in_progress',
  },
  performance_wow_in_progress: {
    label: 'This week to date',
    value: 'performance_wow_in_progress',
    key: 'performance_wow_in_progress',
    range: 'performance_wow_in_progress_range',
    count: 'performance_this_week_to_date',
  },
  performance_last_week: {
    label: 'Last full week',
    value: 'count_last_week',
    key: 'performance_last_week',
    range: 'performance_last_week_range',
    change: 'performance_wow_last_completed',
  },
  count_last_week: {
    label: 'Last full week',
    value: 'count_last_week',
    key: 'count_last_week',
    range: 'performance_last_week_range',
    change: 'wow_last_completed',
  },
  performance_wow_last_completed: {
    label: 'Last full week',
    value: 'performance_wow_last_completed',
    key: 'performance_wow_last_completed',
    range: 'performance_wow_last_completed_range',
    count: 'performance_last_week',
  },
  performance_rtd: {
    label: 'Release to date',
    value: 'performance_rtd',
    key: 'performance_rtd',
    type: 'number',
    range: 'performance_rtd_range',
  },
  artist_count: {
    label: 'Artists',
    value: 'artist_count',
    key: 'artist_count',
    type: 'number',
    range: 'artistCountRange',
  },
  grouped_track_count: {
    label: 'Tracks',
    value: 'grouped_track_count',
    key: 'grouped_track_count',
    type: 'number',
    range: 'trackCountRange',
  },
  grouped_album_count: {
    label: 'Releases',
    value: 'grouped_album_count',
    key: 'grouped_album_count',
    type: 'number',
    range: 'albumCountRange',
  },
  stream_count_this_week_to_date: {
    label: 'This week to date',
    value: 'stream_count_this_week_to_date',
    key: 'stream_count_this_week_to_date',
    type: 'number',
    range: 'streamCountThisWeekToDateRange',
    change: 'stream_wow_in_progress',
  },
  stream_count_last_week_to_date: {
    label: 'Last week to date',
    value: 'stream_count_last_week_to_date',
    key: 'stream_count_last_week_to_date',
    range: 'streamCountLastWeekToDateRange',
  },
  stream_wow_in_progress: {
    label: 'This week to date',
    value: 'stream_wow_in_progress',
    key: 'stream_wow_in_progress',
    range: 'streamWowInProgressRange',
    count: 'stream_count_this_week_to_date',
  },
  this_week_to_date_range: {
    label: 'Change',
    value: 'performance_wow_in_progress',
    key: 'performance_wow_in_progress',
    range: 'thisWeekToDateRange',
    count: 'count_performance_wow_in_progress',
    isRange: true,
  },
  performance_last_week_to_date: {
    label: 'Last week to date',
    value: 'performance_last_week_to_date',
    key: 'performance_last_week_to_date',
    range: 'lastWeekToDateRange',
    count: 'count_last_week_to_date',
  },
  performance_last_week_range: {
    label: 'Change',
    value: 'performance_wow_last_completed',
    key: 'performance_wow_last_completed',
    range: 'performance_wow_last_completed_range',
    count: 'count_performance_wow_last_completed',
    isRange: true,
  },
  performance_last_last_week: {
    label: '2 Weeks ago',
    value: 'performance_last_last_week',
    key: 'performance_last_last_week',
    range: 'performance_last_last_week_range',
    count: 'count_performance_last_last_week',
  },
  displayName: {
    label: 'Display name',
    value: 'displayName',
    key: 'displayName',
  },
  releaseDate: {
    label: 'Release date',
    value: 'releaseDate',
    key: 'releaseDate',
  },

  wow_last_completed: {
    label: 'Change',
    value: 'wow_last_completed',
    key: 'wowLastCompleted',
    range: 'wow_last_completed_range',
    count: 'wow_last_completed',
    isRange: true,
  },
  countryName: {
    label: 'Country',
    value: 'countryName',
    key: 'countryName',
  },

  // Playlist table
  skiprate_this_week_to_date: {
    label: 'Skip rate',
    value: 'skiprate_this_week_to_date',
    key: 'skiprate_this_week_to_date',
  },
  customerId: {
    label: 'DSP',
    value: 'customerId',
    key: 'customerId',
  },
  track_count: {
    label: 'Track count',
    value: 'track_count',
    key: 'track_count',
  },
  new_track_count: {
    label: 'New Track count',
    value: 'new_track_count',
    key: 'new_track_count',
  },
  followers: {
    label: 'Followers',
    value: 'followers',
    key: 'followers',
  },
  position: {
    label: 'Position',
    value: 'position',
    key: 'position',
  },
  entity_track_count: {
    label: 'Entity Track count',
    value: 'entity_track_count',
    key: 'entity_track_count',
  },
  ownerDisplayName: {
    label: 'Owner',
    value: 'ownerDisplayName',
    key: 'ownerDisplayName',
  },
  activity: {
    label: 'Activity',
    value: 'activity',
    key: 'activity',
  },
  lastUpdated: {
    label: 'Last updated',
    value: 'lastUpdated',
    key: 'lastUpdated',
  },
  playlistTerritories: {
    label: 'Playlist territory',
    value: 'countryId',
    key: 'countryId',
  },

  // for Charts
  peak_position: {
    label: 'Peak position',
    value: 'peakPosition',
    key: 'peak_position',
  },
  peak_position_mobile: {
    label: 'Peak position (High to Low)',
    value: 'peakPosition',
    key: 'peak_position',
    sortOrder: 'desc',
  },
  dsp: {
    label: 'DSP',
    value: 'customerName',
    key: 'dsp',
  },
  company: {
    label: 'Company',
    value: 'customerName',
    key: 'company',
  },
  chart: {
    label: 'Chart',
    value: 'chartName',
    key: 'chart',
  },
  countries: {
    label: 'Countries',
    value: 'countryName',
    key: 'countryName',
  },
  territories: {
    label: 'Territories',
    value: 'totalNumberOfCountries',
    key: 'territories',
  },
  date_last_reached: {
    label: 'Date last reached',
    value: 'dateLastReached',
    key: 'date_last_reached',
  },
  product: {
    label: 'Track',
    value: 'productDisplayName',
    key: 'product',
  },
  current_position: {
    label: 'Current position',
    value: 'currentPosition',
    key: 'current_position',
  },
  current_position_mobile: {
    label: 'Current position (High to Low)',
    value: 'currentPosition',
    key: 'current_position',
    sortOrder: 'desc',
  },
  change_position: {
    label: 'Change',
    value: 'changePosition',
    key: 'change_position',
  },
  chart_country: {
    label: 'Chart Country',
    value: 'countryName',
    key: 'chart_country',
  },
  previous_position: {
    label: 'Previous position',
    value: 'previousPosition',
    key: 'previous_position',
  },
  track_streams: {
    label: 'Track Streams on Chart',
    value: 'chartStreams',
    key: 'track_streams',
  },
  last_peak: {
    label: 'Last Peak',
    value: 'peakPosition',
    key: 'last_peak',
  },
  // for Concerts
  date: {
    label: 'Date',
    value: 'date',
    key: 'date',
  },
  country: {
    label: 'country',
    value: 'country',
    key: 'country',
  },
  city: {
    label: 'city',
    value: 'city',
    key: 'city',
  },
  tourName: {
    label: 'name',
    value: 'tourName',
    key: 'tourName',
  },
  venue: {
    label: 'venue',
    value: 'venue',
    key: 'venue',
  },
  certification_country: {
    label: 'country',
    value: 'certification_country',
    key: 'certification_country',
  },
  lastUpdatedAt: {
    label: 'date created',
    value: 'lastUpdatedAt',
    key: 'lastUpdatedAt',
  },
  chartFrequency: {
    label: 'frequency',
    value: 'chartFrequency',
    key: 'chartFrequency',
  },
  llw: {
    label: '2 Weeks ago',
    value: 'llw',
    key: 'llw',
    type: 'number',
  },
  twtd_only: {
    label: 'This week to date',
    value: 'twtd',
    key: 'twtd',
    type: 'number',
  },
  twtd_change: {
    label: 'Change (WTD)',
    value: 'wowInProgress',
    key: 'wowInProgress',
    range: 'twtdRange',
    change: 'wowInProgress',
    isRange: true,
  },
  lw_only: {
    label: 'Last full week',
    value: 'lw',
    key: 'lw',
    type: 'number',
  },
  lfw_change: {
    label: 'Change (LFW)',
    value: 'wowLastCompleted',
    key: 'wowLastCompleted',
    range: 'wowLastCompletedRange',
    change: 'wowLastCompleted',
    isRange: true,
  },

  priorityOnly: {
    label: 'Priority Only',
    value: 'priorityOnly',
    key: 'priorityOnly',
  },
};

export default metrics;
